// Network protocol — message types exchanged between client and relay

import type { PlayerInput } from "../engine/input.js";
import type { ServerInfo } from "./server.js";

export type NetMessage =
  | { type: "welcome"; playerId: number; playerCount: number; mapJson: string; server: ServerInfo }
  | { type: "start"; playerCount: number }
  | { type: "input"; tick: number; playerId: number; input: PlayerInput }
  | { type: "player_joined"; playerId: number; playerCount: number }
  | { type: "player_left"; playerId: number; playerCount: number }
  | { type: "server_full" }
  | { type: "server_closed"; reason: string };

export function encode(msg: NetMessage): string {
  return JSON.stringify(msg);
}

export function decode(data: string): NetMessage {
  return JSON.parse(data);
}
